import { render, staticRenderFns } from "./comentario.vue?vue&type=template&id=ba086ab0"
import script from "./comentario.vue?vue&type=script&lang=js"
export * from "./comentario.vue?vue&type=script&lang=js"
import style0 from "./comentario.vue?vue&type=style&index=0&id=ba086ab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports